/**
 * Dictionaries Navigation
 *
 * Shared navigation component for dictionaries management pages
 */

import { NavLink, useLocation } from 'react-router-dom';

export function DictionariesNavigation() {
  const location = useLocation();

  const navItems = [
    { name: 'Languages', path: '/dictionaries/languages' },
    { name: 'Tutors', path: '/dictionaries/tutors' },
    { name: 'Locales', path: '/dictionaries/locales' },
    { name: 'Tags', path: '/dictionaries/tags' },
    { name: 'Learning Goals', path: '/dictionaries/learning-goals' },
    { name: 'Skill Levels', path: '/dictionaries/skill-levels' },
    { name: 'Episode Durations', path: '/dictionaries/episode-durations' },
    { name: 'Notification Templates', path: '/dictionaries/notification-templates' },
    { name: 'Legal Documents', path: '/dictionaries/legal-documents' },
  ];

  // Helper function to determine if a nav item should be active
  const isNavItemActive = (itemPath: string) => {
    return location.pathname === itemPath;
  };

  return (
    <div className="mb-4 overflow-x-auto border-b border-gray-200">
      <nav className="-mb-px flex space-x-8">
        {navItems.map((item) => {
          const isActive = isNavItemActive(item.path);
          return (
            <NavLink
              key={item.path}
              to={item.path}
              className={`whitespace-nowrap border-b-2 py-3 px-1 text-sm font-medium transition-colors ${
                isActive
                  ? 'border-blue-500 text-blue-600'
                  : 'border-transparent text-gray-500 hover:border-gray-300 hover:text-gray-700'
              }`}
            >
              {item.name}
            </NavLink>
          );
        })}
      </nav>
    </div>
  );
}
